<template>
  <div class="g-wrapper g-vertical-block">
    <div class="g-main-wrapper g-vertical-block main-content">
      <Row :gutter="12">
        <Col span="24">
          <Tabs :value="currentRoute">
            <TabPane name="awemecomplex" label="抖音达人报表"></TabPane>
          </Tabs>
        </Col>
      </Row>
      <div class="c-content">
        <keep-alive :max="10">
          <router-view />
        </keep-alive>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'comprehensivedouyinawenereport',
  data() {
    return {
      currentRoute: 'awemecomplex'
    }
  },
  created() {
    if (this.$route.name === 'comprehensivedouyinawenereport') this.$router.replace({ name: 'awemecomplex' })
  }
}
</script>
<style lang="scss" scoped>
.c-content {
  position: relative;
}
</style>
